/*
 * @providesModule DdLogsWrapper
 * @format
 *
 * Platform-safe wrapper for Datadog Logs.
 * On native platforms, uses @datadog/mobile-react-native.
 * On web, falls back to console logging.
 */

import {Platform} from 'react-native';

// Define the interface for DdLogs methods we use
interface IDdLogs {
  warn: (message: string, context?: Record<string, unknown>) => void;
  info: (message: string, context?: Record<string, unknown>) => void;
  error: (message: string, context?: Record<string, unknown>) => void;
  debug: (message: string, context?: Record<string, unknown>) => void;
}

// Web fallback - logs to console
const webFallback: IDdLogs = {
  warn: (message: string, context?: Record<string, unknown>) => {
    console.warn('[DdLogs.warn]', message, context);
  },
  info: (message: string, context?: Record<string, unknown>) => {
    console.info('[DdLogs.info]', message, context);
  },
  error: (message: string, context?: Record<string, unknown>) => {
    console.error('[DdLogs.error]', message, context);
  },
  debug: (message: string, context?: Record<string, unknown>) => {
    console.debug('[DdLogs.debug]', message, context);
  },
};

// Conditionally load DdLogs only on native platforms
let DdLogsWrapper: IDdLogs;

if (Platform.OS !== 'web') {
  // Dynamic require to avoid loading the module on web
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const {DdLogs} = require('@datadog/mobile-react-native');
  DdLogsWrapper = DdLogs;
} else {
  DdLogsWrapper = webFallback;
}

export default DdLogsWrapper;

